import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// v110: Configurações > Chat Interno (chave geral liga/desliga)
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/chat-interno'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'chat_interno_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
